import React from 'react'
import { motion } from 'framer-motion';
import {pageTransition, pageVariants} from './PageAnimations';

const About = (props) => {
    
    return (
        <motion.div initial="out" animate="in" exit="out" variants={pageVariants} transition={pageTransition} >
            <h2>This is About Component</h2>
            <p>#This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.This is About Component.
                This is About Component.</p>
        </motion.div>
    )
}


export default About;
